export function uuid4(): string {
  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte = () => {
    if (crypto && crypto.getRandomValues) {
      return crypto.getRandomValues(new Uint8Array(1))[0]
    }
    return Math.random() * 16
  }

  return (([1e7] as unknown as string) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    ((c as unknown as number) ^ ((getRandomByte() & 15) >> ((c as unknown as number) / 4))).toString(16),
  );
}

/**
 * 深拷贝
 * 兼容函数，对象，相互引用场景
 * @param target 需要深拷贝的原对象
 * @return 深拷贝后的对象
 */
export function deepCopy<T>(target: T, map = new Map()): T {
  if (target !== null && typeof target === 'object') {
    let res = map.get(target)
    if (res) {
      return res as T
    }
    if (target instanceof Array) {
      res = []
      map.set(target, res)
      target.forEach((item, index) => {
        res[index] = deepCopy(item, map)
      })
    } else {
      res = {}
      map.set(target, res)
      Object.keys(target).forEach(key => {
        // @ts-ignore
        res[key] = deepCopy<any>(target[key], map)
      })
    }
    return res as T
  }
  return target as T
}
